import { RoleCode } from './index'

export const SIDEBAR_MENUS = [ {
	name: 'Medical',
	link: '/medical',
	icon_url: 'fas fa-book-medical',
	access_role: [RoleCode.MEDICALPERSONNEL]
}, {
	name: 'Dashboard',
	link: '/',
	icon_url: 'fe-airplay',
	access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
}, {
	name: 'Resident Profiling',
	icon_url: 'fe-home',
	access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK],
	subs: [{
		name: 'Household',
		link: '/household',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	}, {
		name: 'Constituents',
		link: '/constituents',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	}]
}, {
	name: 'Certificate Management',
	icon_url: 'fe-award',
	access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK],
	subs: [{
		name: 'CTC / OR',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK],
		subs: [{
			name: 'Community Tax Certificate',
			link: '/certificate/community-tax',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}, {
			name: 'Official Receipts',
			link: '/certificate/official-receipt',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}]
	}, {
		name: 'Certificate of Residency',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK],
		subs: [{
			name: 'Certificate of Residency',
			link: '/certificate/residency',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK],
		}, {
			name: 'Certificate of Residency (Application)',
			link: '/certificate/residency-application',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}, {
			name: 'Certificate of Residency (Capitol)',
			link: '/certificate/residency-capitol',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}]
	}, {
		name: 'Certificate of Indigency',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK],
		subs: [{
			name: 'Certificate of Indigency',
			link: '/certificate/indigency-city',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}, {
			name: 'Certificate of Indigency(Solo Parent)',
			link: '/certificate/indigency-solo-parent',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}, {
			name: 'Certificate of Indigency(BIR-SPES)',
			link: '/certificate/indigency',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}]
	}, {
		name: 'Certificate of Loan Clearance',
		link: '/certificate/loan-clearance',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	}, {
		name: 'Certificate of Late Registry',
		link: '/certificate/late-registry',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	}, {
		name: 'Certificate of Guardianship',
		link: '/certificate/guardianship',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	}, {
		name: 'Certificate of Discrepancy',
		link: '/certificate/discrepancy',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	}, {
		name: 'Certificate of Burial',
		link: '/certificate/burial',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	}, {
		name: 'Boat Certification',
		link: '/certificate/boat',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	}, 
	// {
	// 	name: 'Other Certifications',
	// 	access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK],
	// 	subs: [{
	// 		name: 'Common Law',
	// 		link: '/certificate/common-law',
	// 		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	// 	}]
	// }, 
	{
		name: 'Other Certifications',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK],
		subs: [{
			name: 'Common Law',
			link: '/certificate/common-law',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}, 
		// {
		// 	name: 'Penelco',
		// 	link: '/certificate/penelco',
		// 	access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		// }, 
		// {
		// 	name: 'Bapa / Penelco',
		// 	link: '/certificate/bapa-penelco',
		// 	access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		// }, 
		{
			name: 'Next of Kin',
			link: '/certificate/kin',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}, {
			name: 'Business Permit',
			link: '/certificate/business-permit',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}, {
			name: 'Business Closure',
			link: '/certificate/business-closure',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}, {
			name: 'Scholarship',
			link: '/certificate/scholarship',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}]
	},
	{
		name: 'Clearances',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK],
		subs: [{
			name: 'Barangay Clearance',
			link: '/certificate/barangay-clearance',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}, {
			name: 'Business Clearance',
			link: '/certificate/business-clearance',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}, {
			name: 'Construction Clearance',
			link: '/certificate/construction-clearance',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}, {
			name: 'Tricycle Clearance',
			link: '/certificate/tricycle-clearance',
			access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
		}]
	}, {
		name: 'Custom Certificate',
		link: '/certificate/custom',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	},  
	// {
	// 	name: 'Apartment Registration',
	// 	link: '/certificate/apartment-registration',
	// 	access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	// }
	]
}, {
	name: 'Barangay Justice',
	icon_url: 'fe-file',
	// link: '/katarungan-pambarangay',
	access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK],
	subs: [{
		name: 'Complaints',
		link: '/complains',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	}, {
		name: 'Blotter',
		link: '/blotter',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	}]
}, {
	name: 'Barangay Management',
	icon_url: 'fe-clipboard',
	access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK],
	subs: [{
		name: 'Projects',
		link: '/projects',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN]
	}, {
		name: 'Resolutions',
		link: '/resolutions',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN]
	}, {
		name: 'Events',
		link: '/events',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	}, {
		name: 'Facilities Reservation',
		link: '/reservation',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	}, {
		name: 'Equipment',
		link: '/equipment',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN,RoleCode.CLERK]
	}]
}, {
	name: 'Utilities',
	icon_url: 'fe-settings',
	access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN],
	subs: [{
		name: 'System Settings',
		link: '/utilities/settings',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN]
	}, {
		name: 'Data Lookup Management',
		link: '/utilities/lookups',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN]
	}, {
		name: 'Barangay Officials and Staffs',
		link: '/utilities/officials',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN]
	}, {
		name: 'Users',
		link: '/utilities/users',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN]
	}, {
		name: 'Database Backup',
		link: '/utilities/database-backup',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN]
	}, {
		name: 'Visitors QRcode Generator',
		link: '/utilities/visitor-qr-generator',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN]
	}, {
		name: 'Audit Trail',
		link: '/utilities/audit-trail',
		access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN]
	}]
}, {
	name: 'Queries & Reports',
	icon_url: 'fe-printer',
	link: '/reports',
	access_role: [RoleCode.SUPERADMIN,RoleCode.SYSTEMADMIN]
}]